module.exports = __webpack_public_path__ + "img/dar-cu.b2b9eaf6.png";